<section>
  <div>
    <h5>{{ mediaTypeText | translate }}: {{ message | translate }}</h5>
  </div>
  @if (itemsSource && itemsSource.length > 0) {
    <div>
      <app-chart [chartOptions]="chartDefinition"></app-chart>
    </div>
  }
</section>
